import Vue from 'vue';
import BusinessHours from 'vue-business-hours';

Vue.use(BusinessHours);
